export enum TableName {
  RAC = 'RAC',
  PE = 'PE',
  ALI = 'ALI',
  LENDER = 'Lender',
}
